export default __webpack_public_path__ + "static/conTrac2-6fd964171a715438bdc9056619952bbc.jpg";